import BgSpringArrow from "@/assets/svgs/backgrounds/BgSpringArrow";
import { SectionHeadingType } from "@/components/atoms/SectionHeading";
import { HeroPillCategoryEnum_en } from "@/shared/data/hero-pills.data";
import { HeroPillCategoryEnum_kr } from "@/shared/data/hero-pills.data.kr";
import { SuccessStoryType } from "@/shared/types/common.types";
import { Typography } from "@graphy/ui";
import HeroHeading from "../atoms/HeroHeading";
import HeroPill from "../atoms/HeroPill";
import SuccessStoriesGrid from "./SuccessStoriesGrid";

export type CreatorStoriesHeroSectionPropType = {
  heroPill: {
    category:
      | HeroPillCategoryEnum_en.Creators
      | HeroPillCategoryEnum_kr.Creators;
  };
  title: SectionHeadingType;
  description: string;
  successStories: SuccessStoryType[];
};

const CreatorStoriesHeroSection = ({
  heroPill,
  title,
  description,
  successStories,
}: CreatorStoriesHeroSectionPropType) => {
  const renderHero = () => (
    <div className="pt-8 text-left sm:absolute sm:pb-20">
      {/* <div className="absolute bottom-0 right-1/3 hidden h-screen w-screen rounded-br-[300px] border-b border-r sm:block"></div> */}
      {/* <div className="absolute bottom-0 hidden h-screen w-full -translate-x-1/2 rounded-br-[300px] border-b border-r sm:block"></div> */}
      <div className="flex max-w-xs flex-col items-start gap-3">
        <HeroPill category={heroPill.category} />
        <div className="relative pr-4 sm:pr-3">
          <HeroHeading heading={title} />
          <BgSpringArrow className="absolute left-full top-1/2 -translate-y-1/3 scale-75 sm:translate-y-0 sm:scale-100" />
        </div>
        <Typography
          fontSize="text-body"
          colorClass="text-grey-3"
          fontWeight="font-normal"
        >
          {description}
        </Typography>
      </div>
    </div>
  );
  return (
    <div className="~min-h-screen container relative mx-auto flex flex-col gap-8 sm:mt-20">
      {renderHero()}
      <SuccessStoriesGrid successStories={successStories} />
    </div>
  );
};

export default CreatorStoriesHeroSection;
